import { ConnectionStatusType } from '@/components/connection-status/connection-status-type.ts';

export const STREAM_CONNECTION_TOOLTIPS: Record<ConnectionStatusType, string> =
  {
    [ConnectionStatusType.Connected]:
      'Stream is active, real-time data is available',
    [ConnectionStatusType.Connecting]: 'Connecting, please wait',
    [ConnectionStatusType.Disconnected]:
      'Stream connection lost, please reload the page',
  };
